import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/posts/page/[pageNumber]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/app/src/components/Card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/src/components/Pagination/index.tsx");
